import { postApi } from '../../api/api'

export const sendEmail = async ( _, form ) => {
    return await postApi('send-email', form)
}

export const subscribe = async ( _, form ) => {
    return await postApi('subscribe', form)
}